import { Component, OnInit, ViewChild, Output, EventEmitter, AfterViewChecked, Input } from '@angular/core';
import { PaymentStateService } from '../../services/payment-state.service';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { BookingOrderService } from '../../../booking/services/booking-order.service';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { MatDialog } from '@angular/material/dialog';
import { PageAgbPopupComponent } from '../../../../components/page-agb-popup/page-agb-popup.component';
import { OrderStateService } from '../../../order/services/order-state.service';
import { OrderTypeEnum } from 'src/app/modules/order/models/order-type.enum';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})

export class PaymentComponent implements OnInit, AfterViewChecked {

  @ViewChild('paymentDiv', { static: true }) paymentDiv: any;

  private _paymentFormHtml: SafeHtml;
  private _paymentStarted = false;
  private _isCashPayment = false;

  @Input() paymentEnabled = true;

  @Output() eventBack = new EventEmitter();
  @Output() eventPay = new EventEmitter();

  @Input()
  backTitle: string;

  @Input()
  nextTitle: string;

  constructor(
    private paymentStateService: PaymentStateService,
    private sanitizer: DomSanitizer,
    private bookingOrderService: BookingOrderService,
    private shopSettingsService: ShopSettingsService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.isCashPayment = this.bookingOrderService.isCashPayment;
    this.paymentStateService.isCashPayment = this.bookingOrderService.isCashPayment;
  }

  get paymentFormHtml(): SafeHtml {
    if (!this._paymentFormHtml) {
      const paymentForm = this.paymentStateService.paymentFormHtml;
      if (paymentForm && paymentForm.length) {
        this._paymentFormHtml = this.sanitizer.bypassSecurityTrustHtml(paymentForm);
      }
    }
    return this._paymentFormHtml;
  }

  ngAfterViewChecked() {
    if (!this._paymentStarted && this._paymentFormHtml && this.paymentDiv.nativeElement.getElementsByTagName('form').length) {
      this._paymentStarted = true;

      let parentRedirectUrl = null;
      try
      {
        parentRedirectUrl = this.paymentDiv.nativeElement.getElementsByTagName('form')[0].elements.parent_redirect_url.value;
      }
      catch {}

      if (parentRedirectUrl) {
        window.parent.location.href = parentRedirectUrl;
      } else {
        this.paymentDiv.nativeElement.getElementsByTagName('form')[0].submit();
      }
    }
  }

  showAGB(): void {
    this.dialog.open(PageAgbPopupComponent, { height: '90%' });
  }

  onBack(): void {
    this.eventBack.emit();
  }

  onPay(): void {
    this.eventPay.emit();
  }

  get isCashPayment(): boolean {
    return this._isCashPayment;
  }

  set isCashPayment(value: boolean) {
    this._isCashPayment = value;
  }

  get isVuPayment() {
    return this.shopSettingsService.isVUMode;
  }

  get accountPaymentEnabled(): boolean {
    return this.paymentStateService.isPartnerCodePaymentAllowed;
  }

  get showGiftCardRedeem(): boolean {
    return this.shopSettingsService.shopSettings.allowGiftCardPayment
    && !this.isVuPayment
    && !this.shopSettingsService.shopSettings.partnerCodePayment;
  }

  get basketIsReadonly(): boolean {
    return true;
  }

  get isGiftCardOrder(): boolean {
    return this.bookingOrderService
      && this.bookingOrderService.order
      && this.bookingOrderService.order.orderType === OrderTypeEnum.Giftcard;
  }

  get showTermsConditionsLink(): boolean {
    return this.shopSettingsService?.shopSettings?.showTermsConditionsLink;
  }

  get paymentButtonEnabled(): boolean {
    if (this.bookingOrderService.isPartnerHaveMaxOrderCount) {
      return false;
    }

    return this.paymentEnabled;

  }
}
